import * as React from 'react'
import { Property } from 'csstype'

import CardTooltip from 'components/common/CardTooltip'
import Popover from 'components/common/Popover'
import theme from 'theme'

interface TooltipProps extends React.HTMLAttributes<HTMLDivElement> {
  tooltipEnabled: boolean
  contents: () => any
  maxWidth?: Property.MaxWidth
  tooltipSize?: 'base' | 'small'
}

const Tooltip: React.FC<TooltipProps> = ({
  tooltipEnabled,
  contents,
  maxWidth = 250,
  tooltipSize = 'base',
  children = null,
  ...rest
}) => (
  <React.Fragment>
    {tooltipEnabled ? (
      <Popover>
        {({ getTargetProps, getPopoverProps }) => (
          <div
            {...getTargetProps()}
            css={{ display: 'inline-block', marginRight: theme.space[3] }}
            {...rest}
          >
            {children}
            <CardTooltip
              displayArrow
              size={tooltipSize}
              variation="dark"
              {...getPopoverProps({
                css: {
                  maxWidth: maxWidth
                }
              })}
            >
              {contents()}
            </CardTooltip>
          </div>
        )}
      </Popover>
    ) : (
      children
    )}
  </React.Fragment>
)

export default Tooltip
